import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
interface DesktopNavLinksProps {
  onNavigate: (sectionId: string) => void;
}
const DesktopNavLinks = ({
  onNavigate
}: DesktopNavLinksProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleSectionNavigation = (sectionId: string) => {
    if (window.location.pathname !== '/') {
      // Navigate to home first, then scroll to section
      navigate('/');
      setTimeout(() => {
        onNavigate(sectionId);
      }, 300); // Increased timeout for better reliability
    } else {
      // Already on home page, just scroll
      onNavigate(sectionId);
    }
  };
  return <nav className="hidden md:flex items-center justify-center space-x-4 lg:space-x-8">
      <Link to="/products" className="text-sm tracking-wide transition duration-200 hover:text-kbeauty-brown hover:opacity-80">
        {t('nav.products')}
      </Link>
      <Link to="/behind-bottle" className="text-sm tracking-wide transition duration-200 hover:text-kbeauty-brown hover:opacity-80">
        {t('nav.brandHistory')}
      </Link>
      <button onClick={() => handleSectionNavigation('why-it-works')} className="text-sm tracking-wide transition duration-200 hover:text-kbeauty-brown hover:opacity-80">
        {t('nav.whyItWorks')}
      </button>
      <Link to="/reviews" className="text-sm tracking-wide transition duration-200 hover:text-kbeauty-brown hover:opacity-80">
        {t('nav.reviews')}
      </Link>
      <Link to="/faq" className="text-sm tracking-wide transition duration-200 hover:text-kbeauty-brown hover:opacity-80">
        {t('nav.faq')}
      </Link>
      
    </nav>;
};
export default DesktopNavLinks;